import React from 'react';
import TableBody from '../../../../core/table/TableBody';
import { TableColGroup } from '../../../../core/table/TableColGroup';
import TableTitles from '../../../../core/table/TableTitles';
import { useProviderUsageListTableView } from './useProviderUsageListTableView';
import { useProviderEditModel } from './useProviderEditModel';
import TableList from '../../../../core/table/TableList';

export const providerUsageListTableId = 'adminProviderUsageList';

const ProviderUsageListTable = (): JSX.Element => {
    return (
        <TableList>
            <TableWrapper />
        </TableList>
    );
};

const TableWrapper = (): JSX.Element => {
    return (
        <section>
            <table>
                <TableHead />
                <ProviderTableBody />
            </table>
        </section>
    );
};

const TableHead = (): JSX.Element => {
    const { cols, sort } = useProviderUsageListTableView();

    return (
        <>
            <TableColGroup cols={cols} />
            <thead>
                <TableTitles
                    cols={cols}
                    sort={sort}
                />
            </thead>
        </>
    );
};

const ProviderTableBody = (): JSX.Element => {
    const { cols } = useProviderUsageListTableView();
    const { model } = useProviderEditModel();

    return (
        <TableBody
            cols={cols}
            rows={model.Usage}
        />
    );
};

export default ProviderUsageListTable;
